
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"70","viewBox":"0 0 102.711 83.527"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 516"}},[_c('g',{attrs:{"data-name":"Group 510"}},[_c('g',{attrs:{"data-name":"Group 509"}},[_c('g',{attrs:{"data-name":"Group 508"}},[_c('path',{attrs:{"data-name":"Path 693","d":"M70.355 29.207v10.518a5.185 5.185 0 01-5.178 5.179H39.822a5.185 5.185 0 01-5.178-5.179V29.036","fill":"none","stroke":"#707070","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"3.5"}})])]),_c('path',{attrs:{"data-name":"Line 48","fill":"none","stroke":"#707070","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"3.5","d":"M52.473 38.105V19.236"}}),_c('path',{attrs:{"data-name":"Path 694","d":"M46.99 24.175l4.564-4.563a1.282 1.282 0 011.813 0l4.367 4.366","fill":"none","stroke":"#707070","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"3.5"}})]),_c('g',{attrs:{"data-name":"Group 515","transform":"translate(1.75 1.75)","fill":"none","stroke":"#707070","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"3.5"}},[_c('rect',{attrs:{"data-name":"Rectangle 297","width":"99.211","height":"60.069","rx":"5.669"}}),_c('path',{attrs:{"data-name":"Rectangle 298","d":"M34.685 60.069h31.197v13.37H34.685z"}}),_c('rect',{attrs:{"data-name":"Rectangle 299","width":"46.311","height":"6.394","rx":"2.835","transform":"translate(27.128 73.633)"}})])])])
          )
        }
      }
    